import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { DomSanitizer} from '@angular/platform-browser';

/*
*
*  Userguide Page
* 
*/
@Component({
	selector: 'userguide',
  	templateUrl: 'userguide.html'
})
export class Userguide {


    pdfLink:any;
    constructor(
        private navCtrl: NavController, 
        private sanitizer: DomSanitizer
    ) {
        this.pdfLink = this.sanitizer.bypassSecurityTrustResourceUrl('http://docs.google.com/gview?embedded=true&url=https://www.airmont.com/upload/media/userguide.pdf');
    }


}


// WEBPACK FOOTER //
// ./src/pages/userguide/userguide.ts